
import {
  CampaignList,
  GovChart,
  JobChart,
  LandingPage,
  ParticipantsTable,
  QuizAnalysis,
  QuizHome,
  QuizList,
} from "../Compnents/Home";
import { useSelector } from "react-redux";
import { userModel } from "../Interfaces";
import { RootState } from "../Storage/Redux/store";
import { Box, Grid } from "@mui/system";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useState } from "react";
import UserProgressSummeryChart from "../Compnents/Home/UserProgressSummery";
import UserDensityChart from "../Compnents/Home/UserDensityChart";
import UserEngagementPerQuiz from "../Compnents/Home/UserEngagementPerQuiz";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Home() {
  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const isAuthenticated = userData && userData.nameid;

  return (
    <>
      {!isAuthenticated ? (
        <LandingPage />
      ) : userData.role === "Admin" ? (
        <>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" centered>
                <Tab label="Campaign and quiz" {...a11yProps(0)} />
                <Tab label="User analysis" {...a11yProps(1)} />
                <Tab label="User Progress tables" {...a11yProps(2)} />
                <Tab label="Progress Summery" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Grid size={{ md: 6, xs: 12 }}>
                <Box sx={{ mb: 3 }}>
                  <CampaignList />
                </Box>
              </Grid>
              <Grid size={{ md: 6, xs: 12 }} >
                <Box sx={{ mb: 3 }}>
                  <QuizList />
                </Box>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Grid container justifyContent="center" spacing={3}>

                <Grid size={{ md: 6, xs: 12 }} >
                  <Box sx={{ mb: 3 }}>
                    <GovChart />
                  </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }} >
                  <Box sx={{ mb: 3 }}>
                    <JobChart />
                  </Box>
                </Grid>

              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <ParticipantsTable />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <Grid gap={3}>
                <Box mb={3}>
                  <UserEngagementPerQuiz />
                </Box>
                <Box mb={3}>
                  <UserProgressSummeryChart />
                </Box>
                <Box mb={3}>
                  <UserDensityChart />
                </Box>
              </Grid>
            </CustomTabPanel>
          </Box>


        </>
      ) : (


        <QuizHome />

      )}
    </>
  );
}
